import { MyProfilePage } from "./myProfile";
import { MyProfileCaregiverComponent } from "./myProfileCaregiver";
import { MyProfilePatientPage } from "./myProfilePatient";

export const MyProfile = MyProfilePage;

export const MyProfilePatient = MyProfilePatientPage;

export const MyProfileCaregiver = MyProfileCaregiverComponent;
